import React, {useContext, useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import { TextField, Divider } from '@mui/material';
import { inputOnlyNumbers, inputOnlyNumbersWithDot, preventCoordsErrInput } from '../../../utils/CommonUtilities';
import Autocomplete from '@mui/material/Autocomplete';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function ManagePanelDialog(props) {
    const [loading, setLoading] = useState(false);
    const auth = useContext(AuthContext);
    const { notificationSuccess, notificationError } = useNotification();

    const [idEntita, setIdEntita] = useState('');
    const [city, setCity] = useState('');
    const [nome, setNome] = useState('');

    const [comune, setComune] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [toponomia, setToponomia] = useState('');
    const [address, setAddress] = useState('');

    const [lat, setLat] = useState('');
    const [lon, setLon] = useState('');

    const [idFermata, setIdFermata] = useState('');
    const [status, setStatus] = useState('N');
    const [tipologia, setTipologia] = useState('T');

    //const [poiList, setPoiList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [bannerList, setBannerList] = useState([]);

    const [originalNome, setOriginalNome] = useState('');

    const [originalComune, setOriginalComune] = useState('');
    const [originalMunicipio, setOriginalMunicipio] = useState('');
    const [originalToponomia, setOriginalToponomia] = useState('');
    const [originalAddress, setOriginalAddress] = useState('');

    const [originalLat, setOriginalLat] = useState('');
    const [originalLon, setOriginalLon] = useState('');

    const [originalIdFermata, setOriginalIdFermata] = useState('');
    const [originalStatus, setOriginalStatus] = useState('');
    const [originalTipologia, setOriginalTipologia] = useState('');

    //const [originalPoiList, setOriginalPoiList] = useState([]);
    const [originalGroupList, setOriginalGroupList] = useState([]);
    const [originalBannerList, setOriginalBannerList] = useState([]);

    useEffect(() => {
        async function init(){
            if(props.openManagePanelDialog==='mod'){
                setIdEntita(props.lastCellData?.idEntita.S);
                setCity(props.lastCellData?.city.S);
                setNome(props.lastCellData?.nome.S);

                setComune(props.lastCellData?.comune?.S);
                setMunicipio(props.lastCellData?.municipio?.S);
                setToponomia(props.lastCellData?.toponomia?.S);
                setAddress(props.lastCellData?.address?.S);

                setLat(props.lastCellData?.lat?.S);
                setLon(props.lastCellData?.lon?.S);

                setIdFermata(props.lastCellData?.idFermata?.S);
                setStatus(props.lastCellData?.status?.S);
                setTipologia(props.lastCellData?.tipologia?.S);

                setOriginalNome(props.lastCellData?.nome.S);

                setOriginalComune(props.lastCellData?.comune?.S);
                setOriginalMunicipio(props.lastCellData?.municipio?.S);
                setOriginalToponomia(props.lastCellData?.toponomia?.S);
                setOriginalAddress(props.lastCellData?.address?.S);

                setOriginalLat(props.lastCellData?.lat?.S);
                setOriginalLon(props.lastCellData?.lon?.S);
                
                setOriginalIdFermata(props.lastCellData?.idFermata?.S);
                setOriginalStatus(props.lastCellData?.status?.S);
                setOriginalTipologia(props.lastCellData?.tipologia?.S);

                if(props.lastCellData?.groupList?.SS.length > 0){
                    if(props.lastCellData?.groupList?.SS.length === 1 && props.lastCellData?.groupList?.SS[0] === ""){
                        setGroupList([]);
                        setOriginalGroupList([]);
                    }else{
                        let arrValues = [];
                        for (let index = 0; index < props.lastCellData?.groupList?.SS.length; index++) {
                            let found = props.groups.find(item => item.id === props.lastCellData?.groupList?.SS[index]);
                            if(found)arrValues.push(found);
                        }
                        setGroupList(arrValues);
                        setOriginalGroupList(arrValues);
                    }
                }else{
                    setGroupList([]);
                    setOriginalGroupList([]);
                }

                if(props.lastCellData?.bannerList?.SS.length > 0){
                    if(props.lastCellData?.bannerList?.SS.length === 1 && props.lastCellData?.bannerList?.SS[0] === ""){
                        setBannerList([]);
                        setOriginalBannerList([]);
                    }else{
                        let arrValues = [];
                        for (let index = 0; index < props.lastCellData?.bannerList?.SS.length; index++) {
                            let found = props.banners.find(item => item.id === props.lastCellData?.bannerList?.SS[index]);
                            if(found)arrValues.push(found);
                        }
                        setBannerList(arrValues);
                        setOriginalBannerList(arrValues);
                    }
                }else{
                    setBannerList([]);
                    setOriginalBannerList([]);
                }

            }else{
                setIdEntita('');
                setCity('');
                setNome('');
                setOriginalNome('');

                setComune('');
                setMunicipio('');
                setToponomia('');
                setAddress('');

                setOriginalComune('');
                setOriginalMunicipio('');
                setOriginalToponomia('');
                setOriginalAddress('');

                setGroupList([]);
                setOriginalGroupList([]);
                setBannerList([]);
                setOriginalBannerList([]);
                
                setLat('');
                setLon('');
                setOriginalLat('');
                setOriginalLon('');

                setIdFermata('');
                setStatus('N');
                setTipologia('T');
                
                setOriginalIdFermata('');
                setOriginalStatus('');
                setOriginalTipologia('');
            }
        }
        init()
    },[props.openManagePanelDialog])

    const insPanel = async() => {
        try {
            setLoading(true);
        
            if(!idEntita)return;

            const data = {
                idEntita: idEntita,
                nome: nome,
                comune: comune,
                municipio: municipio,
                toponomia: toponomia,
                address: address,
                groupList: groupList.map(el => el.id),
                bannerList: bannerList.map(el => el.id),
                lat: preventCoordsErrInput(lat),
                lon: preventCoordsErrInput(lon),
                idFermata: idFermata,
                status: status,
                tipologia: tipologia,
                city: props.city
            }

            const axiosParams = {
                url: '/ins-panel',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data
            };

            await axios(axiosParams);
            notificationSuccess('Pannello Aggiunto');
            /* 
            if(response.data?.resultsToPass?.some(el => el.status === 'rejected')){
                let arrElementsFailed = response.data.resultsToPass.filter(el => el.status === 'rejected').map(el => el.reason);
                notificationWarning(`I seguenti punti di interesse non sono stati trovati: ${arrElementsFailed}`);
            } */
            await props.getPanels();
            props.handleCloseManagePanelDialog();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    const modPanel = async() => {
        try {
            setLoading(true);

            let areGroupListEqual = checkEqual(groupList.map(el => el.id), originalGroupList.map(el => el.id));
            let areBannerListEqual = checkEqual(bannerList.map(el => el.id), originalBannerList.map(el => el.id));

            const data = {
                nome: nome === originalNome ? '' : nome,

                comune: comune === originalComune ? '' : comune,
                municipio: municipio === originalMunicipio ? '' : municipio,
                toponomia: toponomia === originalToponomia ? '' : toponomia,
                address: address === originalAddress ? '' : address,

                groupList: areGroupListEqual ? false : groupList.map(el => el.id),
                bannerList: areBannerListEqual ? false : bannerList.map(el => el.id),
                lat: lat === originalLat ? '' : preventCoordsErrInput(lat),
                lon: lon === originalLon ? '' : preventCoordsErrInput(lon),

                idFermata: idFermata === originalIdFermata ? '' : idFermata,
                status: status === originalStatus ? '' : status,
                tipologia: tipologia === originalTipologia ? '' : tipologia
            }
            
            const dataToPass = {
                idEntita: idEntita,
                city: city,
                areGroupListEqual,
                areBannerListEqual,
                groupList: groupList.map(el => el.id),
                bannerList: bannerList.map(el => el.id),
                originalGroupList: originalGroupList.map(el => el.id),
                originalBannerList: originalBannerList.map(el => el.id),
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else if(element === 'groupList' || element === 'bannerList'){
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"SS": data[element].length === 0 ? [""] :[...data[element]]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`; 
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }

            const axiosParams = {
                url: '/mod-panel',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: dataToPass
            };

            const response = await axios(axiosParams);
            notificationSuccess('Pannello Aggiornato');

            let newOriginalItems = response.data.responseUpdate.Attributes

            setOriginalNome(newOriginalItems?.nome?.S || '');

            setOriginalComune(newOriginalItems?.comune?.S || '');
            setOriginalMunicipio(newOriginalItems?.municipio?.S || '');
            setOriginalToponomia(newOriginalItems?.toponomia?.S || '');
            setOriginalAddress(newOriginalItems?.address?.S || '');

            setOriginalLat(newOriginalItems?.lat?.S || '');
            setOriginalLon(newOriginalItems?.lon?.S || '');

            setOriginalIdFermata(newOriginalItems?.idFermata?.S || '');
            setOriginalStatus(newOriginalItems?.status?.S || '');
            setOriginalTipologia(newOriginalItems?.tipologia?.S || '');
            
            setOriginalBannerList(newOriginalItems?.bannerList?.SS || []);
            setOriginalGroupList(newOriginalItems?.groupList?.SS || []);

            /* if(response.data?.resultsToPass?.some(el => el.status === 'rejected')){
                let arrElementsFailed = response.data.resultsToPass.filter(el => el.status === 'rejected').map(el => el.reason);
                notificationWarning(`I seguenti punti di interesse non sono stati trovati: ${arrElementsFailed}`);
            } */

            await props.getPanels();
            props.handleCloseManagePanelDialog();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    function checkEqual(a, b) {
        // If lengths of array are not equal means
        // array are not equal
        if (a.length !== b.length) return false;
        a.sort();
        b.sort();
        for (let i = 0; i < a.length; i++){
            if (a[i] !== b[i]){
                return false;
            }
        }
    
        // If all elements were same.
        return true;
    }

    return (
        <Dialog className="dialog-mod-panel" open={props.openManagePanelDialog} onClose={props.handleCloseManagePanelDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{props.openManagePanelDialog === 'ins' ? 'Inserisci impianto' : props?.lastCellData?.nome?.S + ' - ' + props?.lastCellData?.idEntita?.S}</DialogTitle>
            <DialogContent>
                <div className='dialog-panel-wrapper'>
                    <div className='dialog-panel-wrapper-section'>
                        {(props.openManagePanelDialog==='ins')&&(<div className="dialog-panel-fields">
                            <TextField
                                className="dialog-identita required-field-bg"
                                id="dialog-identita"
                                label="Id Impianto"
                                type="text"
                                value={idEntita}
                                onChange={(event) => {
                                    if(inputOnlyNumbers(event.target.value))setIdEntita(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "100px"
                                }}
                            />
                        </div>)}
                        <div className="dialog-panel-fields">
                            <TextField
                                className="dialog-nome required-field-bg"
                                id="dialog-nome"
                                label="Nome"
                                type="text"
                                value={nome}
                                onChange={(event) => {
                                    setNome(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                            />
                            <TextField
                                className="dialog-identita-fermata required-field-bg"
                                id="dialog-identita-fermata"
                                label="Id Fermata"
                                type="text"
                                value={idFermata}
                                onChange={(event) => {
                                    if(inputOnlyNumbers(event.target.value))setIdFermata(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "100px"
                                }}
                            />
                        </div>
                        <Divider variant="middle"/>
                        <div className="dialog-panel-fields">
                            <TextField
                                className="dialog-comune required-field-bg"
                                id="dialog-comune"
                                label="Comune"
                                type="text"
                                value={comune}
                                onChange={(event) => {
                                    setComune(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "50%"
                                }}
                            />
                            <TextField
                                className="dialog-municipio required-field-bg"
                                id="dialog-municipio"
                                label="Municipio"
                                type="text"
                                value={municipio}
                                onChange={(event) => {
                                    setMunicipio(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "50%"
                                }}
                            />
                        </div>
                        <div className="dialog-panel-fields">
                            <TextField
                                className="dialog-toponomia required-field-bg"
                                id="dialog-toponomia"
                                label="Toponomia"
                                type="text"
                                value={toponomia}
                                onChange={(event) => {
                                    setToponomia(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "30%"
                                }}
                            />
                            <TextField
                                className="dialog-address required-field-bg"
                                id="dialog-address"
                                label="Dettaglio Indirizzo"
                                type="text"
                                value={address}
                                onChange={(event) => {
                                    setAddress(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "70%"
                                }}
                            />
                        </div>
                        <div className="dialog-panel-fields">
                            <TextField
                                className="dialog-lat required-field-bg"
                                id="dialog-lat"
                                label="Latitudine"
                                type="text"
                                value={lat}
                                onChange={(event) => {
                                    if(inputOnlyNumbersWithDot(event.target.value))setLat(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "30%"
                                }}
                            />
                            <TextField
                                className="dialog-lon required-field-bg"
                                id="dialog-longitudine"
                                label="Longitudine"
                                type="text"
                                value={lon}
                                onChange={(event) => {
                                    if(inputOnlyNumbersWithDot(event.target.value))setLon(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "30%"
                                }}
                            />
                        </div>
                        <div className="dialog-panel-fields">
                            <FormControl sx={{width: '30%'}} variant='standard'>
                                <InputLabel id="tipologia-select-label">Tipologia</InputLabel>
                                <Select
                                    labelId="tipologia-select-label"
                                    id="tipologia-select"
                                    value={tipologia}
                                    label="Tipologia"
                                    onChange={(event) => setTipologia(event.target.value)}
                                >
                                    <MenuItem value={'T'}>Totem</MenuItem>
                                    <MenuItem value={'P'}>Palina</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl sx={{width: '30%'}} variant='standard'>
                                <InputLabel id="status-select-label">Status</InputLabel>
                                <Select
                                    labelId="status-select-label"
                                    id="status-select"
                                    value={status}
                                    label="Status"
                                    onChange={(event) => setStatus(event.target.value)}
                                >
                                    <MenuItem value={'N'}>Non Attivo</MenuItem>
                                    <MenuItem value={'Y'}>Attivo</MenuItem>
                                    <MenuItem value={'G'}>Guasto</MenuItem>
                                    <MenuItem value={'NS'}>Non in Servizio</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    {/* <TextField
                                className="dialog-status required-field-bg"
                                id="dialog-status"
                                label="Status"
                                type="text"
                                value={status === 'G' ? 'Guasto' : status === 'Y' ? 'Attivo' : 'Non Attivo'}
                                variant="standard"
                                style={{
                                    width: "30%"
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    }
                                }}
                            /> */}
                        <Divider variant="middle"/>
                    <div className="dialog-panel-fields">
                        <Autocomplete
                            className="groupList-autocomplete"
                            multiple
                            options={props.groups}
                            disableCloseOnSelect
                            value={groupList}
                            limitTags={5}
                            onChange={(event, newValue) => {
                                setGroupList([...newValue]);
                            }}
                            getOptionLabel={(option) => `${option.label}`}
                            style={{ minWidth: 250 }}
                            renderInput={(params) => (
                                <TextField
                                    className="group-autocomplete-textfield"
                                    {...params}
                                    label="Gruppo"
                                    variant="standard"
                                />
                            )}
                        />
                        <Autocomplete
                            className="bannerList-autocomplete"
                            multiple
                            options={props.banners}
                            disableCloseOnSelect
                            value={bannerList}
                            limitTags={5}
                            onChange={(event, newValue) => {
                                setBannerList([...newValue]);
                            }}
                            getOptionLabel={(option) => `${option.label}`}
                            style={{ minWidth: 250 }}
                            renderInput={(params) => (
                                <TextField
                                    className="banner-autocomplete-textfield"
                                    {...params}
                                    label="Banner"
                                    variant="standard"
                                />
                            )}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={() => props.openManagePanelDialog === 'ins' ? insPanel() : modPanel()}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseManagePanelDialog}>
                    Esci
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ManagePanelDialog